const channelName = (caseUuid: string) => `case-proposals:${caseUuid}`

const PROPOSAL_RESOLVED = 'proposal-resolved'

export const postProposalResolved = (caseUuid: string) => {
  if (typeof BroadcastChannel === 'undefined') return
  const channel = new BroadcastChannel(channelName(caseUuid))
  channel.postMessage({ type: PROPOSAL_RESOLVED })
  channel.close()
}

export const subscribeProposalResolved = (caseUuid: string, handler: () => void): (() => void) => {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const channel = new BroadcastChannel(channelName(caseUuid))
  channel.onmessage = (event) => {
    if (event.data?.type === PROPOSAL_RESOLVED) handler()
  }
  return () => channel.close()
}
